import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
// import { PlanskaKalkulacijaComponent } from './pages/planska-kalkulacija/planska-kalkulacija.component';

@Injectable()
export class AppConfig {
  //port 7085 nas test
  public static ipAddress = 'https://lab.fortuno.hr:1991/api/';
  public static IPfile: string = "https://lab.fortuno.hr:1991";

  //pekar live https
  //public static ipAddress = 'https://proizvodnja.pekar.hr:3051/api/';
  //public static IPfile: string = "https://proizvodnja.pekar.hr:3051";
  
  //pekar live http
  //public static ipAddress = 'http://proizvodnja.pekar.hr:3049/api/';
  //public static IPfile: string = "http://proizvodnja.pekar.hr:3049";
}

export function moduli() {
  return {
    rasporedLjudi: 'RASPORED LJUDI',
    djelatnici: 'DJELATNICI',
    djelatnikPrava: 'DJELATNIK PRAVA',
    godisnjiOdmori: 'GODIŠNJI ODMORI',
    izostanci1: 'IZOSTANCI',
    izostanci2: 'IZOSTANCI',
    dezurstvo: 'DEŽURSTVO',
    prijaveOdjaveDjelatnika: 'PRIJAVE/ODJAVE DJELATNIKA',
    nadzornaPloca: 'NADZORNA PLOČA',
    planProizvodnjePoDanima: 'PLAN PROIZVODNJE PO DANIMA',
    planProizvodnjePoLinijama: 'PLAN PROIZVODNJE PO LINIJAMA',
    dnevniIzvjestajZavrsenihRN: 'DNEVNI IZVJEŠTAJ ZAVRŠENIH RN',
    kapacitetLinija: 'KAPACITET LINIJA',
    proizvodProcesi: 'PROIZVOD: PROCESI',
    sifarnikProcesi: 'ŠIFARNIK: PROCESI',
    linijaStrojevi: 'LINIJA: STROJEVI',
    skladisteSirovinaAmbalaza: 'SKLADIŠTE SIROVINA I AMBALAŽA',
    ispisPlana: 'ISPIS PLANA',
    pregledIzdatnica: 'PREGLED IZDATNICA',
    pregledIzdatnicaTrosak: 'PREGLED IZDATNICA TROŠAK',
    pregledIzdatnicaPotrosniMaterijala: 'PREGLED IZDATNICA POTROŠNI MATERIJAL',
    pregledRevers: 'PREGLED REVERS',
    pregledZahtjevaZaSirovine: 'PREGLED ZAHTJEVA ZA SIROVINE',
    signalniLagerSirovina: 'SIGNALNI LAGER SIROVINA',
    naljepniceLotoviStanja: 'NALJEPNICE, LOTOVI, STANJA',
    naljepniceZaIspis: 'NALJEPNICE ZA ISPIS',
    pregledPoLotovima: 'PREGLED PO LOTOVIMA',
    dostavnice: 'DOSTAVNICE',
    naruceneKolicine: 'NARUČENE KOLIČINE',
    naruceneKolicinePoGrupi: 'NARUČENE KOLIČINE PO GRUPI',
    stanjeSkladista: 'STANJE SKLADIŠTA',
    skladisteHlad: 'SKLADIŠTE HLAD',
    akcijeBosoNtl: 'AKCIJE BOSO I NTL',
    akcijeHrvatska: 'AKCIJE HRVATSKA',
    akcijeInozemstvo: 'AKCIJE INOZEMSTVO',
    ostvareniSati: 'OSTVARENI SATI',
    partneri: 'PARTNERI',
    proizvodiNaAkciji: 'PROIZVODI NA AKCIJI',
    dostavnicaHlad: 'DOSTAVNICA HLAD',
    planskaKalkulacija: 'PLANSKA KALKULACIJA',
    dokumenti: "PREGLED NAPRAVLJENIH DOKUMENATA",
    primke: "PRIMKE",
    rekapitulacijaUlaza: "REKAPITULACIJA ULAZA",
    rekapitulacijaIzdatnica: "REKAPITULACIJA IZDATNICA",
    lotNaljepnice: "LOT NALJEPNICE",
    sifarnikProizvodi: 'ŠIFARNIK: PROIZVODI',
    narudzbe: 'NARUDŽBE',
    uredjaji: 'UREĐAJI',
    rokoviTrajanja: 'ROKOVI TRAJANJA',
    otpremnice: 'OTPREMNICE',
    radninaloziDokumenti: 'RADNI NALOZI DOKUMENTI',
    digitalnaPloca: 'DIGITALNA PLOČA',
    meduskladisnicaIzlaz: 'MEĐUSKLADIŠNICA IZLAZ',
    meduskladisnicaZaMrvice: 'MEĐUSKLADIŠNICA ZA MRVICE',
    karticaArtikla: 'KARTICA ARTIKLA',
  };
}
